import { useAccess } from "src/hooks/useAccess.hook";
import editFill from "@iconify/icons-eva/edit-fill";
import deleteFill from "@iconify/icons-eva/trash-2-outline";
import viewFill from "@iconify/icons-eva/eye-fill";
import Flip2Fill from "@iconify/icons-eva/flip-2-fill";
import chargerIcon from "@iconify/icons-eva/flash-outline";
import { ActionsMenu } from "../Actions/ActionsMenu";
import { useMutate } from "src/hooks/useFetch.hook";
import { getTeamUrl, tagIdUrl } from "src/react-query/endPoints";
import { useSelectedTeam } from "src/hooks/useSelectedTeam";
import { useCallback, useMemo } from "react";
import { FEATURE } from "src/util/enums";
import { useDispatch } from "react-redux";
import { dialogSlice } from "src/store/dailog/dailog.slice";

export const TagActionMenu = ({ id, row }) => {
  const dispatch = useDispatch();
  const isReadOnly = useAccess(FEATURE.TAG, "R");
  const hasEditAccess = useAccess(FEATURE.TAG, "U");
  const hasDeleteAccess = useAccess(FEATURE.TAG, "D");
  const { teamId } = useSelectedTeam();
  const { mutate } = useMutate("tags");

  const onDelete = useCallback(() => {
    mutate({ url: getTeamUrl(teamId, tagIdUrl(id)), method: "DELETE" });
  }, [teamId, id, mutate]);

  const attachCharger = useCallback(() => {
    dispatch(
      dialogSlice.actions.setDialog({
        open: true,
        id: { row },
      })
    );
  }, [dispatch, row]);

  const actionList = useMemo(
    () => [
      {
        id: "view",
        title: "View",
        icon: viewFill,
        routerLink: `/tag/${id}`,
        hidden: !isReadOnly,
      },
      {
        id: "edit",
        title: "Edit",
        icon: editFill,
        routerLink: `/tag/${id}`,
        hidden: !hasEditAccess,
      },
      {
        id: "delete",
        title: "Delete",
        icon: deleteFill,
        action: onDelete,
        hidden: !hasDeleteAccess,
      },
      {
        id: "transactions",
        title: "View Transactions",
        icon: Flip2Fill,
        routerLink: `/transactions?tag=${id}`,
      },
      {
        id: "attach",
        title: "Attach Charger",
        icon: chargerIcon,
        action: attachCharger,
      },
    ],
    [id, isReadOnly, hasEditAccess, hasDeleteAccess, onDelete, attachCharger]
  );

  return <ActionsMenu menuList={actionList} />;
};
